module.exports = __webpack_public_path__ + "img/logo-tappbell.32dbf852.png";